// extracted by mini-css-extract-plugin
export default {"container":"error_container__pZL-j","content":"error_content__yXDPC","text":"error_text__eCZRB"};